// apps/mtd-itsa-web/src/pages/transaction-entry.tsx
//  put “which business / which country / which propertyId” context in the page, then pass that context into the form via props


import React from "react";
import { TransactionForm } from "@/components/application/data-entry/transaction-form";

// transaction-entry.tsx
export default function TransactionEntry() {
    return (
        <div className="mx-auto w-full max-w-2xl px-4">
            <TransactionForm onSubmit={(data) => console.log(data)} />
        </div>
    );
}

